module.exports = __webpack_public_path__ + "static/media/remove.9a872d86.svg";